// extracted by mini-css-extract-plugin
export default {"legal_text":"TermsAndPrivacyText_legal_text__K19Ha","pressable_text":"TermsAndPrivacyText_pressable_text__xc7Vv"};